import { useTranslation } from 'react-i18next';
import ModalFrame from '../primitives/ModalFrame';


interface NavigationConfirmModalProps {
  isOpen: boolean;
  destination: 'shop' | 'hall_of_fame' | 'city_hall';
  onConfirm: () => void;
  onClose: () => void;
}

export default function NavigationConfirmModal({
  isOpen,
  destination,
  onConfirm,
  onClose,
}: NavigationConfirmModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const getMessage = (): string => {
    if (destination === 'shop') {
      return t("Do you want to visit the Store?");
    } else if (destination === 'city_hall') {
      return t("Do you want to visit the Town Hall?");
    }
    return t("Do you want to visit the Hall of Fame?");
  };

  return (
    <ModalFrame
      isOpen={isOpen}
      onClose={onClose}
      title={t("Confirmation required")}
      variant="dialog"
      backdropClassName="modal-frame-bottom-gradient [--modal-frame-gradient-max-width:520px]"
      showBackButton={true}
    >
      {/* Повідомлення */}
      <div
        className="mb-3xl [font-family:Lato,sans-serif] text-[16px] leading-[22px] font-normal tracking-[-0.747px] text-white not-italic"
      >
        {getMessage()}
        <div
          className="mt-md [font-family:Lato,sans-serif] text-[14px] leading-[18px] font-light tracking-[-0.747px] text-white opacity-80 not-italic"
        >
          ({t("The map will be closed")})
        </div>
      </div>

        {/* Кнопки */}
        <div
          className="flex justify-end gap-lg"
        >
          <button
            onClick={onClose}
            className="cursor-pointer rounded-md border border-solid border-white-alpha-30 bg-transparent px-3xl py-lg [font-family:Lato,sans-serif] text-[16px] font-normal text-white transition-all duration-200 ease-[ease] hover:bg-white-alpha-10"
          >
            {t("Cancel")}
          </button>
          <button
            onClick={onConfirm}
            className="cursor-pointer rounded-md border-none bg-[image:var(--gradient-onboarding-action)] px-3xl py-lg [font-family:Lato,sans-serif] text-[16px] font-normal text-white transition-all duration-200 ease-[ease] hover:opacity-90"
          >
            {t("OK")}
          </button>
        </div>
    </ModalFrame>
  );
}
